import {
  SEARCH_HEDGEFUND,
  GET_REGION,
  FOLLOW_FUND,
  GET_STRATEGY,
  GET_SUBSPECIALTY,
  CREATE_RECOMMENDFUND
} from "./constants";

export function searchHedgeFund(payload) {
  return {
    type: SEARCH_HEDGEFUND,
    payload,
  };
}

export function getStrategies(payload) {
  return {
    type: GET_STRATEGY,
    payload,
  };
}

export function getRegion() {
  return {
    type: GET_REGION,
  };
}

export function followFund(fundId, follow, onSuccess) {
  return {
    type: FOLLOW_FUND,
    fundId,
    follow,
    onSuccess,
  };
}
export function getSubspecialties(id) {
  return {
    type: GET_SUBSPECIALTY,
    id,
  };
}

export function CreateRecommendedFund(payload, onSuccess , onModalClose) {
  return {
    type: CREATE_RECOMMENDFUND,
    payload ,
    onSuccess,
    onModalClose
  };
}